import script from "./AbcScore.vue?vue&type=script&setup=true&lang=js"
export * from "./AbcScore.vue?vue&type=script&setup=true&lang=js"

import "./AbcScore.vue?vue&type=style&index=0&id=59973d2d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59973d2d"]])

export default __exports__